// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendie-wtb-button,.via-list,.via-modal{font-family:sans-serif}.vendie-wtb-button:hover{cursor:pointer}@media (max-height:636px){.via-modal{align-items:unset!important}.via-modal-content{margin:auto!important}}", ""]);
// Exports
module.exports = exports;
